import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { api, ApiClientError } from '../lib/api';

export function VerifyBanner() {
  const { user, isAuthenticated } = useAuth();
  const toast = useToast();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  if (!isAuthenticated || !user || user.emailVerified || dismissed) return null;

  const resend = async () => {
    setSending(true);
    try {
      const res = await api.auth.requestVerification();
      if (res.alreadyVerified) {
        toast.push('Your email is already verified', 'info');
      } else if (res.devLink) {
        // Dev convenience when email delivery isn't configured.
        toast.push('Verification link logged (dev mode)', 'info');
        window.open(res.devLink, '_blank');
      } else if (res.delivered === 'logged') {
        // Honest feedback: the server couldn't actually send the email.
        toast.push('Email delivery isn’t set up yet — please contact support to verify your account', 'error');
      } else {
        toast.push('Verification email sent — check your inbox', 'success');
      }
    } catch (e) {
      toast.push(e instanceof ApiClientError ? e.message : 'Could not send verification email', 'error');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="verify-banner">
      <span>
        <strong>Verify your email</strong> to secure your account.
      </span>
      <span className="verify-banner-actions">
        <button className="btn btn-ghost btn-sm" onClick={resend} disabled={sending}>
          {sending ? 'Sending…' : 'Resend link'}
        </button>
        <button className="btn btn-ghost btn-sm" onClick={() => setDismissed(true)} aria-label="Dismiss">
          ✕
        </button>
      </span>
    </div>
  );
}
